import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, mobileHero, mobileHeroText } from 'images'
import ViewMenu from './ViewMenu'
import ReserveButton from './ReserveButton'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="105VH"
          w="100%"
          image={`url(${mobileHero}) center / cover no-repeat`}
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
          column
          justifyBetween
          alignCenter
        >
          <CFImage src={mobileHeroText} w="80%" alt="Promotions" mt="15px" />
          <CFView bg="rgba(0,0,0,.8)" pt="15px" w="100%" textCenter>
            <CFView pulsate>
              <OrderPickupButton />
            </CFView>
            {/* <CFView mt="8px">
              <ViewMenu />
            </CFView> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="95vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) top/ cover no-repeat`}
          zIndex={90}
          column
          justifyBetween
          alignCenter
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
        >
          <Header />
          <CFView
            row
            center
            alignCenter
            w="100%"
            maxWidth="800px"
            bg="rgba(0,0,0,.8)"
            pt="5px"
          >
            <CFView column justifyStart mr="20px">
              <CFText hero raleway white xBold style={{ fontSize: 30 }}>
                NOW TAKING ONLINE ORDERS
              </CFText>
            </CFView>
            <CFView pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
